import React from 'react';
import { SectionWrapper } from './Shared';
import { XCircle } from 'lucide-react';
export const FailedAttemptsSection = () => {
  const attempts = [{
    title: 'Las dietas de hambre',
    desc: 'Solo elevan tu estrés y sabotean tu producción hormonal.'
  }, {
    title: 'El cardio excesivo',
    desc: 'Te drena y le dice a tu cuerpo que debe "sobrevivir", no "prosperar".'
  }, {
    title: 'Los suplementos milagrosos',
    desc: 'No funcionan si tu fábrica hormonal nocturna está cerrada por falta de sueño.'
  }, {
    title: 'Beber café todo el día',
    desc: 'Es solo un parche que oculta un sistema biológico agotado.'
  }];
  return <SectionWrapper className="bg-dark-800" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <h2 className="font-oswald text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-36">
            Por qué lo que has intentado{' '}
            <span className="text-red-500" data-id="element-37">no funcionó</span>
          </h2>
          <div className="w-24 h-1 bg-red-500/50 mx-auto rounded-full" data-id="element-38"></div>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-39">
          {attempts.map((item, idx) => <div key={idx} className="flex gap-4 bg-dark-900 p-6 rounded-xl border border-white/5" data-id="element-40">
              <XCircle className="w-8 h-8 text-red-500 shrink-0 mt-1" data-id="element-41" />
              <div data-id="element-42">
                <h3 className="font-bold text-white text-lg mb-2" data-id="element-43">
                  {item.title}
                </h3>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed" data-id="element-44">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};